const pendingWrites = new Set<Promise<unknown>>();

export function trackPendingWrite<T>(write: Promise<T>): Promise<T> {
  pendingWrites.add(write);
  void write.then(() => pendingWrites.delete(write), () => pendingWrites.delete(write));
  return write;
}

export async function flushPendingWrites(): Promise<void> {
  while (pendingWrites.size > 0) {
    await Promise.allSettled([...pendingWrites]);
  }
}
